var article;

article = function() {
  var $, module, moduleName, progressbar;
  moduleName = 'article';
  $ = require('jquery');
  module = $("." + moduleName);
  if (module.length < 1) {
    return false;
  }
  progressbar = require('../../components/progressbar/progressbar');
  return progressbar({
    elemSelectorProgress: "." + moduleName,
    barColor: '#24b862'
  });
};

module.exports = article;
